import React from 'react';
import useOrg from '../hooks/useOrg';

export default function OrgRoute({ children }: { children: JSX.Element }) {
  // load current org if in url

  useOrg();
  return children;
}
